export default __webpack_public_path__ + "static/IBMPlexSans-Italic-Cyrillic-c781dd3e68cf4db696e2275be474d4d8.woff2";